"use strict";
/*
* Created on 23.05.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductPlacementConverter.
 *
 * @author ZSr
 */


var ProductPlacementConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductPlacementConverter, _DataObjectConverter_);

  function ProductPlacementConverter() {
    _classCallCheck(this, ProductPlacementConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPlacementConverter).apply(this, arguments));
  }

  return ProductPlacementConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductPlacementConverter = ProductPlacementConverter;